import { type ExternalDocument, externalDocumentFromDb } from '@eflight/shared/dist/paperwork/externalDocuments';

import { type QueryFactory2, type QueryResult } from '../../Admin/Datasources/QueryFactory';
import { type CreateExternalDocumentInput } from '../../API';
import { type ListQueryReturn } from '../LocalDB/types';

export const externalDocumentItemFields = `
    id
    createdAt
    identifyingData
    flightDocumentId
    flightId
    legId
    reservationId
    reservationEventId
    notIdentified
    contentKey
    contentData
    deleted
    _version
    _deleted
`;

type ListExternalDocumentsReturnType = ListQueryReturn<'listExternalDocuments', CreateExternalDocumentInput>;
export const listExternalDocumentsNotIdentified: QueryFactory2<
    ListExternalDocumentsReturnType,
    { nextToken?: string; legId?: string }
> = (variables) => {
    const queryCommand = variables?.legId
        ? `listExternalDocumentsByLegId(
          limit: 200
          nextToken: $nextToken
          legId: $legId
          sortDirection: DESC
        )`
        : `listExternalDocumentsByNotIdentified(
          limit: 50
          nextToken: $nextToken
          notIdentified: "x"
          sortDirection: DESC
        )`;
    const query = `
      query ListExternalDocuments(
        $nextToken: String
        ${variables?.legId ? '$legId: ID' : ''}
      ) {
        listExternalDocuments: ${queryCommand} {
          items {
            ${externalDocumentItemFields}
          }
          nextToken
        }
      }
`;
    return { query, variables };
};

export function listExternalDocumentsQueryToArray(input: QueryResult<ListExternalDocumentsReturnType>): {
    nextToken: string | null;
    externalDocuments: ExternalDocument[];
} {
    const externalDocuments = input.data.listExternalDocuments.items.map(externalDocumentFromDb);
    externalDocuments.sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime());
    const { nextToken } = input.data.listExternalDocuments;
    return { externalDocuments, nextToken };
}

// Types and the DB transform live in @eflight/shared (flight paperwork errors in the mcpServer lambda).
export * from '@eflight/shared/dist/paperwork/externalDocuments';
